import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grid from "@material-ui/core/Grid";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import React from "react";

interface ButtonOptionType {
	label: string;
	onClick: () => void;
	isMainButton?: boolean;
}

export interface SplitButtonProps {
	options: Array<ButtonOptionType>;
	mainButtonStyles?: React.CSSProperties;
}
export default function SplitButton({ options, mainButtonStyles }: SplitButtonProps) {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const mainButton = options.find((option) => option.isMainButton);
	const filteredOptions = options.filter((option) => option.label !== mainButton?.label);

	const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
		filteredOptions[index].onClick();
		setOpen(false);
	};

	const handleToggle = () => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event: React.MouseEvent<Document, MouseEvent>) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	return (
		<Grid container direction="column" alignItems="center">
			<Grid item xs={12}>
				<ButtonGroup variant="contained" color="primary" ref={anchorRef} aria-label="split button">
					<Button onClick={mainButton?.onClick} style={mainButtonStyles} id="mainButton">
						{mainButton?.label}
					</Button>
					<Button
						color="primary"
						size="small"
						aria-controls={open ? "split-button-menu" : undefined}
						aria-expanded={open ? "true" : undefined}
						aria-label="select merge strategy"
						aria-haspopup="menu"
						onClick={handleToggle}
					>
						<ArrowDropDownIcon />
					</Button>
				</ButtonGroup>
				<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
					{({ TransitionProps, placement }) => (
						<Grow
							{...TransitionProps}
							style={{
								transformOrigin: placement === "bottom" ? "center top" : "center bottom",
							}}
						>
							<Paper>
								<ClickAwayListener onClickAway={handleClose}>
									<MenuList id="split-button-menu">
										{filteredOptions.map((option, index) => (
											<MenuItem
												id={`optionButton${index}`}
												key={index}
												// disabled={index === 2}
												// selected={index === selectedIndex}
												onClick={(event) => handleMenuItemClick(event, index)}
											>
												{option.label}
											</MenuItem>
										))}
									</MenuList>
								</ClickAwayListener>
							</Paper>
						</Grow>
					)}
				</Popper>
			</Grid>
		</Grid>
	);
}
